webpackJsonp([20],{

/***/ 1121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrizesView_vue__ = __webpack_require__(1278);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05d91edf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrizesView_vue__ = __webpack_require__(1446);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrizesView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05d91edf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrizesView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Prizes_PrizesResultsTable__ = __webpack_require__(1440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Prizes_PrizesCutoutsTable__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__composables_prizes_usePrizesView__ = __webpack_require__(1444);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'PrizesView',
  components: {
    TabLayout: __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__["a" /* default */],
    PageHeading: __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__["a" /* default */],
    PrizesResultsTable: __WEBPACK_IMPORTED_MODULE_3__components_Prizes_PrizesResultsTable__["a" /* default */],
    PrizesCutoutsTable: __WEBPACK_IMPORTED_MODULE_4__components_Prizes_PrizesCutoutsTable__["a" /* default */]
  },
  setup: function setup() {
    var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])(),
        proxy = _getCurrentInstance.proxy;

    var eventId = proxy.$route.params.eventId;

    var _usePrizesView = Object(__WEBPACK_IMPORTED_MODULE_5__composables_prizes_usePrizesView__["a" /* default */])(eventId),
        rounds = _usePrizesView.rounds,
        activeRound = _usePrizesView.activeRound,
        activeRoundData = _usePrizesView.activeRoundData,
        cutouts = _usePrizesView.cutouts,
        eventName = _usePrizesView.eventName,
        loading = _usePrizesView.loading,
        downloadingPdf = _usePrizesView.downloadingPdf,
        fetchPrizes = _usePrizesView.fetchPrizes,
        setWinner = _usePrizesView.setWinner,
        downloadPdf = _usePrizesView.downloadPdf;

    fetchPrizes();
    return {
      rounds: rounds,
      activeRound: activeRound,
      activeRoundData: activeRoundData,
      cutouts: cutouts,
      eventName: eventName,
      loading: loading,
      downloadingPdf: downloadingPdf,
      setWinner: setWinner,
      downloadPdf: downloadPdf
    };
  }
}));

/***/ }),

/***/ 1279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'PrizesResultsTable',
  props: {
    results: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    totalPayouts: {
      type: String,
      default: '0.00'
    }
  }
}));

/***/ }),

/***/ 1280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'PrizesCutoutsTable',
  props: {
    cutouts: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isFinalRound: {
      type: Boolean,
      default: false
    }
  },
  emits: ['make-winner'],
  setup: function setup(props, ctx) {
    var hasWinner = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.cutouts.some(function (c) {
        return c.isWinner;
      });
    });

    function makeWinner(cutout) {
      ctx.emit('make-winner', cutout);
    }

    return {
      hasWinner: hasWinner,
      makeWinner: makeWinner
    };
  }
}));

/***/ }),

/***/ 1440:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrizesResultsTable_vue__ = __webpack_require__(1279);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f7d7a92_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrizesResultsTable_vue__ = __webpack_require__(1441);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrizesResultsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f7d7a92_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrizesResultsTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1441:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cutout__container"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.results),function(result){return _c('ul',{key:result.id,staticClass:"table__body"},[_c('li',{staticClass:"num_type"},[_vm._v(_vm._s(result.place))]),_vm._v(" "),_c('li',{staticClass:"rider_name"},[_c('strong',[_vm._v(_vm._s(result.rider))]),(result.riderDeleted)?_c('small',{staticClass:"text-primary ml-1"},[_vm._v("(deleted)")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"display-md"},[_c('strong',[_vm._v("Horse: ")]),_vm._v(_vm._s(result.horse)),(result.horseDeleted)?_c('small',{staticClass:"text-primary ml-1"},[_vm._v("(deleted)")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"display-md"},[_c('strong',[_vm._v("Owner: ")]),_vm._v(_vm._s(result.owner))])]),_vm._v(" "),_c('li',{staticClass:"hidden-md"},[_vm._v(_vm._s(result.horse)),(result.horseDeleted)?_c('small',{staticClass:"text-primary ml-1"},[_vm._v("(deleted)")]):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"hidden-md"},[_vm._v(_vm._s(result.owner))]),_vm._v(" "),_c('li',{staticClass:"num_type text-left"},[_vm._v(_vm._s(result.score))]),_vm._v(" "),_c('li',{staticClass:"num_type text-left"},[_vm._v(_vm._s(result.payout))])])}),_vm._v(" "),_c('strong',{staticClass:"total_payouts"},[_c('span',[_vm._v("Total Payouts: ")]),_vm._v(" "),_c('span',[_vm._v("$"+_vm._s(_vm.totalPayouts))])])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"table__header"},[_c('li',{staticClass:"num_type text-center"},[_vm._v("Place")]),_vm._v(" "),_c('li',{staticClass:"rider_name"},[_vm._v("Rider")]),_vm._v(" "),_c('li',{staticClass:"hidden-md"},[_vm._v("Horse")]),_vm._v(" "),_c('li',{staticClass:"hidden-md"},[_vm._v("Owner")]),_vm._v(" "),_c('li',{staticClass:"num_type"},[_vm._v("Score")]),_vm._v(" "),_c('li',{staticClass:"num_type"},[_vm._v("$")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1442:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrizesCutoutsTable_vue__ = __webpack_require__(1280);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2304df0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrizesCutoutsTable_vue__ = __webpack_require__(1443);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrizesCutoutsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2304df0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrizesCutoutsTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1443:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_vm._l((_vm.cutouts),function(cutout){return _c('ul',{key:cutout.id,staticClass:"table__body",class:{ is_winner: cutout.isWinner }},[_c('li',[_vm._v("\n      "+_vm._s(cutout.rider)+"\n      "),_c('div',{staticClass:"display-mob"},[_vm._v("Horse: "+_vm._s(cutout.horse))])]),_vm._v(" "),_c('li',{staticClass:"hidden-mob"},[_vm._v(_vm._s(cutout.horse))]),_vm._v(" "),_c('li',{staticClass:"cutout_value"},[_vm._v(_vm._s(cutout.cutoutScore))]),_vm._v(" "),_c('li',{staticClass:"actions"},[(cutout.isWinner)?_c('span',[_vm._v("Winner")]):(!_vm.hasWinner)?_c('a',{staticClass:"btn-make-winner",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.makeWinner(cutout)}}},[_vm._v("\n        Make winner\n      ")]):_vm._e()])])})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"table__header"},[_c('li',[_vm._v("Rider")]),_vm._v(" "),_c('li',{staticClass:"hidden-mob"},[_vm._v("Horse")]),_vm._v(" "),_c('li',{staticClass:"cutout_value"},[_vm._v("Cutout")]),_vm._v(" "),_c('li')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1444:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = usePrizesView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_prizes__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_EventBus__ = __webpack_require__(18);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }





function mapPlace(p) {
  return {
    id: p.id,
    place: p.place_name,
    rider: p.member,
    riderDeleted: p.member_deleted,
    horse: p.horse,
    horseDeleted: p.horse_deleted,
    owner: p.owner,
    score: p.score,
    payout: p.amount != null ? p.amount.toFixed(2) : '0.00'
  };
}

function mapRound(r) {
  return {
    id: r.calc_round_id,
    label: r.is_final ? 'Final round' : "Round ".concat(r.order),
    isFinal: r.is_final,
    competitors: r.places_number,
    payingPlaces: r.places_number,
    judges: r.judge_name != null ? r.judge_name : '',
    totalPayouts: r.total_payouts != null ? r.total_payouts.toFixed(2) : '0.00',
    results: (r.places != null ? r.places : []).map(mapPlace)
  };
}

function mapCutout(c) {
  return {
    id: c.id,
    rider: c.member_name,
    horse: c.horse_name,
    cutoutScore: c.cutout,
    isWinner: c.is_winner,
    drawId: c.id
  };
}

function usePrizesView(eventId) {
  var rounds = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var roundsData = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])({});
  var cutouts = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var eventName = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])('');
  var activeRound = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
  var loading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var activeRoundData = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    if (activeRound.value == null) return null;
    return roundsData.value[activeRound.value] != null ? roundsData.value[activeRound.value] : null;
  });

  function fetchPrizes() {
    return _fetchPrizes.apply(this, arguments);
  }

  function _fetchPrizes() {
    _fetchPrizes = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var res, d, apiRounds, mapped, dataMap;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.prev = 1;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_prizes__["a" /* default */].getPrizes(eventId);

            case 4:
              res = _context.sent;
              d = res.data.data;
              apiRounds = d.rounds != null ? d.rounds : [];
              mapped = apiRounds.map(mapRound);
              rounds.value = mapped.map(function (r) {
                return {
                  id: r.id,
                  label: r.label,
                  isFinal: r.isFinal
                };
              });
              dataMap = {};
              mapped.forEach(function (r) {
                dataMap[r.id] = r;
              });
              roundsData.value = dataMap;
              cutouts.value = (d.cutOutsList != null ? d.cutOutsList : []).map(mapCutout);
              eventName.value = d.eventName != null ? d.eventName : '';

              if (mapped.length > 0 && activeRound.value == null) {
                activeRound.value = mapped[0].id;
              }

              _context.next = 22;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](1);
              rounds.value = [];
              roundsData.value = {};
              cutouts.value = [];

            case 22:
              _context.prev = 22;
              loading.value = false;
              return _context.finish(22);

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 17, 22, 25]]);
    }));
    return _fetchPrizes.apply(this, arguments);
  }

  function setWinner(_x) {
    return _setWinner.apply(this, arguments);
  }

  function _setWinner() {
    _setWinner = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(cutout) {
      var target;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_prizes__["a" /* default */].setCutoutWinner(eventId, cutout.drawId);

            case 3:
              cutouts.value.forEach(function (c) {
                c.isWinner = false;
              });
              target = cutouts.value.find(function (c) {
                return c.id === cutout.id;
              });
              if (target) target.isWinner = true;
              _context2.next = 10;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 8]]);
    }));
    return _setWinner.apply(this, arguments);
  }

  var downloadingPdf = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

  function downloadPdf() {
    return _downloadPdf.apply(this, arguments);
  }

  function _downloadPdf() {
    _downloadPdf = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3() {
      var res, blobUrl;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!downloadingPdf.value) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return");

            case 2:
              downloadingPdf.value = true;
              _context3.prev = 3;
              _context3.next = 6;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_prizes__["a" /* default */].getFinalPdf(eventId);

            case 6:
              res = _context3.sent;
              blobUrl = window.URL.createObjectURL(new Blob([res.data], {
                type: 'application/pdf'
              }));
              window.open(blobUrl, '_blank');
              _context3.next = 14;
              break;

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](3);
              __WEBPACK_IMPORTED_MODULE_2__store_EventBus__["a" /* default */].$emit('http-error', 'Failed to download PDF');

            case 14:
              _context3.prev = 14;
              downloadingPdf.value = false;
              return _context3.finish(14);

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 11, 14, 17]]);
    }));
    return _downloadPdf.apply(this, arguments);
  }

  return {
    rounds: rounds,
    activeRound: activeRound,
    activeRoundData: activeRoundData,
    cutouts: cutouts,
    eventName: eventName,
    loading: loading,
    downloadingPdf: downloadingPdf,
    fetchPrizes: fetchPrizes,
    setWinner: setWinner,
    downloadPdf: downloadPdf
  };
}

/***/ }),

/***/ 1445:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  getPrizes: function getPrizes(eventId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/events/".concat(eventId, "/prizes"));
  },
  setCutoutWinner: function setCutoutWinner(eventId, drawId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/events/".concat(eventId, "/draws/").concat(drawId, "/cutout-winner"), {}, {
      silent: true
    });
  },
  getFinalPdf: function getFinalPdf(eventId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/events/".concat(eventId, "/prizes/final-round-pdf"), {
      responseType: 'blob'
    });
  }
});

/***/ }),

/***/ 1446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"full-width":true}},[_c('div',{staticClass:"bg-white rounded mb-4 p-3",attrs:{"slot":"tabContent"},slot:"tabContent"},[_c('page-heading',[_vm._v("Event results")]),_vm._v(" "),_c('div',{staticClass:"prizes__title"},[_c('h3',{staticClass:"h3 mb-3"},[_vm._v(_vm._s(_vm.eventName))]),_vm._v(" "),_c('a',{staticClass:"draws__download-table prizes__pdf-icon",class:{ 'draws__download--loading': _vm.downloadingPdf },attrs:{"href":"#","title":"Download PDF"},on:{"click":function($event){$event.preventDefault();return _vm.downloadPdf($event)}}})]),_vm._v(" "),_c('div',{staticClass:"draws"},[_c('div',{staticClass:"draws-tabs"},[_c('div',{staticClass:"draws-tabs__header"},[_c('div',{staticClass:"draws-tabs__btn-wrap filter _prizes"},_vm._l((_vm.rounds),function(round){return _c('div',{key:round.id,staticClass:"form-check pl-0 draws-tabs__btn",class:{ active: _vm.activeRound === round.id },on:{"click":function($event){_vm.activeRound = round.id}}},[_c('div',{staticClass:"draws-tabs__btn-text form-check-label"},[_vm._v("\n                "+_vm._s(round.label)+"\n              ")])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"draws-tabs__content-wrap"},[_c('div',{staticClass:"draws-tabs__content active"},[_c('div',{staticClass:"drafts-view bg-lighter border-top px-3 py-4 my-4"},[_c('div',{staticClass:"drafts-view__item mb-3"},[_c('span',{staticClass:"drafts-view__item-label"},[_vm._v("Competitors:")]),_vm._v(" "),_c('span',{staticClass:"drafts-view__item-content"},[_vm._v(_vm._s(_vm.activeRoundData != null ? _vm.activeRoundData.competitors : ''))])]),_vm._v(" "),_c('div',{staticClass:"drafts-view__item mb-3"},[_c('span',{staticClass:"drafts-view__item-label"},[_vm._v("Paying places:")]),_vm._v(" "),_c('span',{staticClass:"drafts-view__item-content"},[_vm._v(_vm._s(_vm.activeRoundData != null ? _vm.activeRoundData.payingPlaces : ''))])]),_vm._v(" "),_c('div',{staticClass:"drafts-view__item drafts-view__item-form mb-3 d-flex"},[_c('span',{staticClass:"drafts-view__item-label mr-1"},[_vm._v("Judges: ")]),_vm._v(" "),_c('span',{staticClass:"judge-list"},[_vm._v(_vm._s(_vm.activeRoundData != null ? _vm.activeRoundData.judges : ''))])])]),_vm._v(" "),_c('prizes-results-table',{attrs:{"results":_vm.activeRoundData != null ? _vm.activeRoundData.results : [],"total-payouts":_vm.activeRoundData != null ? _vm.activeRoundData.totalPayouts : '0.00'}}),_vm._v(" "),_c('div',{staticClass:"cutout__container"},[_c('h3',{staticClass:"drafts__title"},[_vm._v("Highest Cutouts")]),_vm._v(" "),_c('prizes-cutouts-table',{attrs:{"cutouts":_vm.cutouts,"is-final-round":_vm.activeRoundData != null ? _vm.activeRoundData.isFinal : false},on:{"make-winner":_vm.setWinner}})],1)],1)])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/20.1e836871d72dc887e6c6.js